<form [formGroup]="advertisingCenterFormGroup" class="category-content">
    <div class="data-container light-border">
        <span class="data-title"> Chargé de Clientèle </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input matInput formControlName="customerServiceManager" [matAutocomplete]="autoCustomerServiceManager" />
                <mat-autocomplete
                    autoActiveFirstOption
                    class="tv-custom-always-visible-scroll-bar"
                    #autoCustomerServiceManager="matAutocomplete"
                    [displayWith]="displayAutoCompleteData">
                    <mat-option
                        *ngFor="let customerServiceManager of filteredCustomerServiceManagerList | async"
                        class="tv-ns-select-option"
                        [value]="customerServiceManager">
                        {{ customerServiceManager.name }} - {{ customerServiceManager.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <div class="data-container light-border">
        <span class="data-title"> Agence </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input matInput formControlName="otherCentralAgency" [matAutocomplete]="autoOtherCentralAgency" />
                <mat-autocomplete
                    autoActiveFirstOption
                    class="tv-custom-always-visible-scroll-bar"
                    #autoOtherCentralAgency="matAutocomplete"
                    [displayWith]="displayAutoCompleteData">
                    <mat-option
                        *ngFor="let otherCentralAgency of filteredOtherCentralAgencyList | async"
                        class="tv-ns-select-option"
                        [value]="otherCentralAgency">
                        {{ otherCentralAgency.name }} - {{ otherCentralAgency.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <div class="data-container light-border">
        <span class="data-title"> Commercial </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input matInput formControlName="commercialAgent" [matAutocomplete]="autoCommercialAgent" />
                <mat-autocomplete
                    autoActiveFirstOption
                    class="tv-custom-always-visible-scroll-bar"
                    #autoCommercialAgent="matAutocomplete"
                    [displayWith]="displayAutoCompleteData">
                    <mat-option
                        *ngFor="let commercialAgent of filteredCommercialAgentList | async"
                        class="tv-ns-select-option"
                        [value]="commercialAgent">
                        {{ commercialAgent.name }} - {{ commercialAgent.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
